(function () {
  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function getPicker() {
    return document.querySelector("variant-picker") || document.querySelector("[data-variant-picker]");
  }

  function getFieldsets(picker) {
    return picker ? Array.from(picker.querySelectorAll("fieldset")) : [];
  }

  function getControls(group) {
    if (!group) return [];
    const radios = Array.from(group.querySelectorAll("input[type='radio']"));
    if (radios.length) return radios;
    return Array.from(group.querySelectorAll("button"));
  }

  function getWrapper(ctrl) {
    return (
      ctrl.closest(".variant-picker__input") ||
      ctrl.closest(".variant-picker__option") ||
      ctrl.closest("label") ||
      ctrl.closest("li") ||
      ctrl.closest(".swatch") ||
      ctrl.closest(".radio-wrapper") ||
      ctrl
    );
  }

  // Detect disabled/unavailable in multiple theme patterns (including line-through cross style)
  function isDisabled(ctrl) {
    const w = getWrapper(ctrl);

    const style = w ? window.getComputedStyle(w) : null;
    const hasLineThrough =
      style &&
      ((style.textDecorationLine && style.textDecorationLine.includes("line-through")) ||
        (style.textDecoration && style.textDecoration.includes("line-through")));

    return (
      !!hasLineThrough ||
      ctrl.disabled ||
      ctrl.getAttribute("aria-disabled") === "true" ||
      (w && w.getAttribute("aria-disabled") === "true") ||
      (w &&
        (w.classList.contains("disabled") ||
          w.classList.contains("is-disabled") ||
          w.classList.contains("soldout") ||
          w.classList.contains("is-soldout") ||
          w.classList.contains("unavailable") ||
          w.classList.contains("is-unavailable")))
    );
  }

  function isSelected(ctrl) {
    if (ctrl.tagName === "INPUT") return ctrl.checked;
    return (
      ctrl.getAttribute("aria-pressed") === "true" ||
      ctrl.getAttribute("aria-current") === "true" ||
      ctrl.classList.contains("is-selected") ||
      ctrl.classList.contains("active")
    );
  }

  function clickCtrl(ctrl) {
    ctrl.click();
    if (ctrl.tagName === "INPUT") {
      ctrl.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function hideDisabledTempleOptions(templeGroup) {
    const controls = getControls(templeGroup);

    controls.forEach((ctrl) => {
      const w = getWrapper(ctrl);
      w.style.display = isDisabled(ctrl) ? "none" : "";
    });

    // If selected is invalid/hidden, auto-pick first available
    const selected = controls.find(isSelected);
    if (!selected || isDisabled(selected)) {
      const firstOk = controls.find((c) => !isDisabled(c));
      if (firstOk) clickCtrl(firstOk);
    }
  }

  onReady(() => {
    const picker = getPicker();
    if (!picker) return;

    const sets = getFieldsets(picker);
    if (sets.length < 2) return;

    const frameGroup = sets[0];
    const templeGroup = sets[1];

    // Hide Temple on page load
    templeGroup.style.display = "none";

    const frameControls = getControls(frameGroup);

    let rafScheduled = false;
    let lastRun = 0;

function forceTempleHorizontal(templeGroup) {
  // fieldset ko flex bana do
  templeGroup.style.setProperty("display", "flex", "important");
  templeGroup.style.setProperty("flex-wrap", "wrap", "important");
  templeGroup.style.setProperty("gap", "12px", "important");
  templeGroup.style.setProperty("align-items", "center", "important");

  // andar ke wrappers/buttons ko auto width do (no full width bars)
  const items = templeGroup.querySelectorAll("label, li, button, .variant-picker__input, .variant-picker__option");
  items.forEach(el => {
    el.style.setProperty("width", "auto", "important");
    el.style.setProperty("max-width", "none", "important");
    el.style.setProperty("flex", "0 0 auto", "important");
    el.style.setProperty("white-space", "nowrap", "important");
    // kuch themes display:block kar dete hain
    if (el.tagName !== "BUTTON") el.style.setProperty("display", "inline-flex", "important");
  });
}


   function runFilter() {
  // show temple
  templeGroup.style.setProperty("display", "flex", "important");
  forceTempleHorizontal(templeGroup);

  // 🔥 run immediately (removes flash)
  hideDisabledTempleOptions(templeGroup);

  // run again on next paint
  requestAnimationFrame(() => hideDisabledTempleOptions(templeGroup));

  // run again after Shopify async updates disabled states
  setTimeout(() => hideDisabledTempleOptions(templeGroup), 60);
  setTimeout(() => hideDisabledTempleOptions(templeGroup), 180);
}


    function scheduleFilter() {
      const now = Date.now();
      if (now - lastRun < 120) return; // throttle
      lastRun = now;

      if (rafScheduled) return;
      rafScheduled = true;

      requestAnimationFrame(() => {
        rafScheduled = false;
        runFilter();
      });
    }

    // Trigger only on Frame change
    frameControls.forEach((c) => {
      c.addEventListener("click", scheduleFilter);
      c.addEventListener("change", scheduleFilter);
    });

    // Watch temple group only (safe, no hang)
    const mo = new MutationObserver(() => scheduleFilter());
    mo.observe(templeGroup, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "disabled", "aria-disabled", "style"],
    });
  });
})();
